// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2840":"cab6504a","4476":"e62a6c74","4564":"a1c42139","4913":"e1316be7","7910":"30b63223"}[chunkId] + ".chunk.css";
};